export default "__VITE_ASSET__DY9$YrR7__"